import _createForOfIteratorHelper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import Xt from "../models/backend-errors.js";
import ue from "../models/braze-event.js";
import { convertMsToSeconds as X, convertSecondsToMs as Yt } from "../util/date-utils.js";
import c from "../common/event-logger.js";
import { isArray as D, isEqual as ii } from "../util/code-utils.js";
import { logger as E, EventTypes as m } from "../../shared-lib/index.js";
import { STORAGE_KEYS as s } from "./storage-manager.js";
import h from "../util/request-header-utils.js";
import { LAST_REQUEST_TO_ENDPOINT_MS_AGO_DEFAULT as Zt, MAX_RETRY_COUNT_PER_REQUEST as he } from "../common/constants.js";
import { getAlias as ce } from "./utils.js";
import { readResponseHeaders as ve } from "../util/net.js";
var Mt = /*#__PURE__*/function () {
  function Mt(t, e, i, s, r, n, o, a, h, u, l, c) {
    _classCallCheck(this, Mt);
    this.on = t, this.j = e, this.Qh = i, this.Cs = s, this.C = r, this.h = n, this.sn = o, this.Ea = a, this.Xh = h, this.Zh = u, this.appVersion = l, this.$a = c, this.Xa = function (t) {
      return null == t ? "" : "".concat(t, " ");
    }, this.on = t, this.j = e, this.Qh = i, this.Cs = s, this.C = r, this.h = n, this.sn = o, this.Ea = a, this.Xh = h, this.Zh = u, this.appVersion = l, this.$a = c, this.Ya = ["npm"], this.Za = {};
  }
  _createClass(Mt, [{
    key: "$",
    value: function $(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var r = this.on.fe(!i),
        n = r.Ar(),
        o = this.j.lt(s.ct.Qa);
      ii(o, n) || (t.device = n), t.api_key = this.sn, t.time = X(new Date().valueOf(), !0);
      var a = this.j.lt(s.ct.au) || [],
        h = this.j.lt(s.ct.du) || "";
      this.Ya.length > 0 && (!ii(a, this.Ya) || h !== this.C.bt()) && (t.sdk_metadata = this.Ya), t.sdk_version = this.Xh, this.Zh && (t.sdk_flavor = this.Zh), t.app_version = this.appVersion, t.app_version_code = this.$a, t.device_id = r.id;
      var u = this.Cs.getUserId();
      if (e && null !== u && (t.user_id = u), !u && !this.Qh.fh()) {
        var _e = ce(this.j);
        _e && (t.alias = _e);
      }
      return t;
    }
  }, {
    key: "Y",
    value: function Y(t, e, i) {
      var s = e.auth_error,
        r = e.error;
      if (!s && !r) return !0;
      if (s) {
        var _e2;
        this.Qh.Gh();
        var _r = {
          errorCode: s.error_code
        };
        var _iterator = _createForOfIteratorHelper(i),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _t = _step.value;
            D(_t) && "X-Braze-Auth-Signature" === _t[0] && (_r.signature = _t[1]);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        t.respond_with && t.respond_with.user_id ? _r.userId = t.respond_with.user_id : t.user_id && (_r.userId = t.user_id);
        var n = s.reason;
        return n ? (_r.reason = n, _e2 = "due to ".concat(n)) : _e2 = "with error code ".concat(s.error_code, "."), this.Qh.fh() || (_e2 += ' Please use the "enableSdkAuthentication" initialization option to enable authentication.'), E.error("SDK Authentication failed ".concat(_e2)), this.fu(t.events || [], t.attributes || []), this.Qh.yh(_r), !1;
      }
      if (r) {
        var _i,
          _s = r;
        switch (_s) {
          case Xt.vu:
            return _i = "Received successful response with empty body.", c.rt(m.pu, {
              e: _i
            }), E.info(_i), !1;
          case Xt.Ru:
            return _i = "Received successful response with invalid JSON", c.rt(m.pu, {
              e: _i + ": " + e.response
            }), E.info(_i), !1;
          case Xt.gu:
            _s = "The API key \"".concat(t.api_key, "\" is invalid for the baseUrl ").concat(this.Ea);
            break;
          case Xt.bu:
            _s = "Sorry, we are not currently accepting your requests. If you think this is in error, please contact us.";
            break;
          case Xt.qu:
            _s = "No device identifier. Please contact support@braze.com";
        }
        E.error("Backend error: " + _s);
      }
      return !1;
    }
  }, {
    key: "Au",
    value: function Au(t, e, i) {
      return !!(t && 0 !== t.length || e && 0 !== e.length || i);
    }
  }, {
    key: "Du",
    value: function Du(t, e, i) {
      var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var r = [],
        n = function n(t) {
          return t || "";
        },
        o = n(this.Cs.getUserId());
      var a = this.Mr(t);
      var u = [],
        l = [];
      var c,
        d = null;
      if (e.length > 0) {
        var _t2 = [];
        var _iterator2 = _createForOfIteratorHelper(e),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _i2 = _step2.value;
            if (c = _i2.Ar(), this.Qh.fh()) {
              if (o && !c.user_id) {
                d || (d = {}), d.events || (d.events = []), d.events.push(c);
                continue;
              }
              if (n(c.user_id) !== o) {
                l.push(c);
                continue;
              }
            }
            _t2.push(c);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        _t2.length > 0 && (a.events = _t2);
      }
      if (i.length > 0) {
        var _t3 = [];
        var _iterator3 = _createForOfIteratorHelper(i),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _e3 = _step3.value;
            _e3 && (this.Qh.fh() && n(_e3.user_id) !== o ? u.push(_e3) : _t3.push(_e3));
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        _t3.length > 0 && (a.attributes = _t3);
      }
      if (this.fu(l, u), a = this.$(a, !1, s), d) {
        d = this.$(d, !1, s);
        var _t4 = {
          requestData: d,
          headers: this.A(d, h.H.Tu)
        };
        r.push(_t4);
      }
      if (a && !this.Au(a.events, a.attributes, t)) return d ? r : null;
      var f = {
        requestData: a,
        headers: this.A(a, h.H.Tu)
      };
      return r.push(f), r;
    }
  }, {
    key: "fu",
    value: function fu(t, e) {
      if (t) {
        var _e4 = [];
        var _iterator4 = _createForOfIteratorHelper(t),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var i = _step4.value;
            var _t5 = ue.fromJson(i);
            _t5.time = Yt(_t5.time), _e4.push(_t5);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        this.j.Eo(_e4);
      }
      if (e) {
        var _iterator5 = _createForOfIteratorHelper(e),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _t6 = _step5.value;
            this.j.ku(_t6);
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
    }
  }, {
    key: "_",
    value: function _(t, e) {
      var i = "HTTP error ";
      null != t && (i += t + " "), i += e, E.error(i);
    }
  }, {
    key: "yu",
    value: function yu(t) {
      return c.rt(m.wu, {
        n: t
      });
    }
  }, {
    key: "Mr",
    value: function Mr(t, e) {
      var i = {};
      t && (i.triggers = !0);
      var s = null != e ? e : this.Cs.getUserId();
      if (s && (i.user_id = s), !i.user_id && !this.Qh.fh()) {
        var _t7 = ce(this.j);
        _t7 && (i.alias = _t7);
      }
      return i.config = {
        config_time: this.h.Ft()
      }, {
        respond_with: i
      };
    }
  }, {
    key: "Nu",
    value: function Nu(t) {
      var e = new Date().valueOf();
      var i = Zt.toString();
      var s = h.Cu(this.j, t);
      if (-1 !== s) {
        i = (e - s).toString();
      }
      return i;
    }
  }, {
    key: "A",
    value: function A(t, e) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var s = [["X-Braze-Api-Key", this.sn]],
        r = this.Nu(e);
      s.push(["X-Braze-Last-Req-Ms-Ago", r]);
      var n = h.Su(this.j, e).toString();
      s.push(["X-Braze-Req-Attempt", n]);
      var o = !1;
      if (null != t.respond_with && t.respond_with.triggers && (s.push(["X-Braze-TriggersRequest", "true"]), o = !0), e === h.H.bi) {
        s.push(["X-Braze-ContentCardsRequest", "true"]);
        var _t8 = h.Su(this.j, h.H.bi);
        _t8 && !i || (_t8 = 1, h.Bu(this.j, h.H.bi, _t8));
        var _e5 = Math.max(0, _t8 - 1);
        s.push(["BRAZE-SYNC-RETRY-COUNT", _e5.toString()]), o = !0;
      }
      if (e === h.H.$e && (s.push(["X-Braze-FeatureFlagsRequest", "true"]), o = !0), o && s.push(["X-Braze-DataRequest", "true"]), this.Qh.fh()) {
        var _t9 = this.Qh.wh();
        null != _t9 && s.push(["X-Braze-Auth-Signature", _t9]);
      }
      return s;
    }
  }, {
    key: "zu",
    value: function zu(t, e, i, s) {
      var _this = this;
      if (this.Za[s]) return;
      var r = window.setTimeout(function () {
        E.info("Retrying rate limited ".concat(_this.Xa(s), "SDK request.")), _this.J(e, i, s);
      }, t);
      this.Za[s] = r;
    }
  }, {
    key: "fo",
    value: function fo() {
      for (var t in this.Za) {
        var e = this.Za[t];
        window.clearTimeout(e);
      }
      this.Za = {};
    }
  }, {
    key: "J",
    value: function J(t, e, i, r) {
      if (!this.ju(i)) return E.info("".concat(this.Xa(i), "SDK request being rate limited.")), void ("function" == typeof r && r());
      var n = this.Mu();
      if (!n.$u) return this.zu(n.Xu, t, e, i), void E.info("".concat(this.Xa(i), "SDK request being rate limited. Request will be retried in ").concat(Math.trunc(n.Xu / 1e3), " seconds."));
      this.j.ft(s.ct.Lu, new Date().valueOf());
      var o = t.device;
      o && o.os_version instanceof Promise ? o.os_version.then(function (i) {
        t.device.os_version = i, e(n.Eu);
      }) : e(n.Eu);
    }
  }, {
    key: "Fu",
    value: function Fu(t) {
      var e = t ? ve(t) : null;
      if (!e || !e["retry-after"]) return null;
      var i = e["retry-after"];
      if (isNaN(i) && !isNaN(Date.parse(i))) return {
        type: "date",
        value: Date.parse(i)
      };
      if (!isNaN(parseFloat(i.toString()))) return {
        type: "timestamp",
        value: 1e3 * parseFloat(i.toString())
      };
      {
        var _t10 = "Received unexpected value for retry-after header in /sync response";
        c.rt(m.pu, {
          e: _t10 + ": " + i
        });
      }
      return null;
    }
  }, {
    key: "st",
    value: function st(t, e, i, s, r, n) {
      var _this2 = this;
      if (h.Su(this.j, i) >= he) return;
      var o;
      n = n || 0;
      var a = this.Fu(t);
      r();
      var u = function u(t) {
        var r = window.setTimeout(function () {
          e();
        }, t);
        s(r), h.Ku(_this2.j, i);
      };
      if (a && !isNaN(a.value)) {
        switch (a.type) {
          case "date":
            o = a.value - new Date().getTime() + n, o < 0 && e();
            break;
          case "timestamp":
            o = a.value + n;
        }
        u(o);
      } else n ? u(n) : h.Ci(this.j, i);
    }
  }, {
    key: "Iu",
    value: function Iu(t) {
      var e;
      null === (e = this.j) || void 0 === e || e.ft(s.ct.Pu, t);
    }
  }, {
    key: "Uu",
    value: function Uu(t, e) {
      var i = this.xu();
      null == i && (i = {}), i[t] = e, this.j.ft(s.ct.Hu, i);
    }
  }, {
    key: "Ou",
    value: function Ou() {
      var t;
      return null === (t = this.j) || void 0 === t ? void 0 : t.lt(s.ct.Pu);
    }
  }, {
    key: "xu",
    value: function xu() {
      var t;
      return null === (t = this.j) || void 0 === t ? void 0 : t.lt(s.ct.Hu);
    }
  }, {
    key: "Gu",
    value: function Gu(t, e, i, s) {
      var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "";
      var n;
      if (r) {
        var _t11 = this.xu();
        n = null == _t11 || isNaN(_t11[r]) ? e : _t11[r];
      } else n = this.Ou(), (null == n || isNaN(n)) && (n = e);
      var o = (t - s) / 1e3;
      return n = Math.min(n + o / i, e), n;
    }
  }, {
    key: "_u",
    value: function _u(t, e) {
      return Math.max(0, (1 - t) * e * 1e3);
    }
  }, {
    key: "Wu",
    value: function Wu(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var i, r, n, o, a;
      var u = {
        $u: !0,
        Eu: -1,
        Xu: 0
      };
      if (null == t && (t = !0), !t && !e) return u;
      var l,
        c,
        d = null;
      if (t) d = null === (i = this.j) || void 0 === i ? void 0 : i.lt(s.ct.Lu);else {
        var _t12 = h.Yu(this.j);
        if (null == _t12 || null == _t12[e]) return u;
        d = _t12[e];
      }
      if (null == d || isNaN(d)) return u;
      if (t ? (l = (null === (r = this.h) || void 0 === r ? void 0 : r.Ju()) || -1, c = (null === (n = this.h) || void 0 === n ? void 0 : n.Qu()) || -1) : (l = (null === (o = this.h) || void 0 === o ? void 0 : o.Vu(e)) || -1, c = (null === (a = this.h) || void 0 === a ? void 0 : a.Zu(e)) || -1), -1 === l || -1 === c) return u;
      var f = new Date().valueOf();
      var m = this.Gu(f, l, c, d, e);
      return m < 1 ? (u.$u = !1, u.Xu = this._u(m, c), u) : (m = Math.trunc(m) - 1, u.Eu = m, t ? this.Iu(m) : this.Uu(e, m), u);
    }
  }, {
    key: "Mu",
    value: function Mu() {
      return this.Wu(!0);
    }
  }, {
    key: "ju",
    value: function ju(t) {
      var e = this.Wu(!1, t);
      return !(e && !e.$u);
    }
  }, {
    key: "Z",
    value: function Z() {
      this.Qh.Z();
    }
  }, {
    key: "V",
    value: function V() {
      return this.Ea;
    }
  }, {
    key: "addSdkMetadata",
    value: function addSdkMetadata(t) {
      var _iterator6 = _createForOfIteratorHelper(t),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var e = _step6.value;
          -1 === this.Ya.indexOf(e) && this.Ya.push(e);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
  }]);
  return Mt;
}();
export { Mt as default };